$( ->
  $(document).on 'click', 'a[data-toggle="collapse"]', ->
    the_link = $(this)
    return false unless the_link.data('collapsed')?
    unless the_link.data('original-text')?
      the_link.data('original-text', the_link.text())
      the_collapse = $(the_link.attr('href'))
      the_collapse.on 'shown.bs.collapse', ->
        the_link.text(the_link.data('collapsed'))
      the_collapse.on 'hidden.bs.collapse', ->
        the_link.text(the_link.data('original-text'))
    false

  $(document).on 'change', '.collapse-on-change', ->
    if $(this).attr('type') == 'checkbox'
      if $(this).prop('checked')
        $('#' + $(this).data('target')).collapse('show')
      else
        $('#' + $(this).data('target')).collapse('hide')
    else if $(this).attr('type') == 'radio'
      $(this).closest('.input').find('.collapse-on-change').each ->
        $('#' + $(this).data('target')).collapse('hide')
      $('#' + $(this).data('target')).collapse('show')
    else
      if $(this).data('test') == 'present'
        if $(this).val() == ''
          $('#' + $(this).data('target')).collapse('hide')
        else
          $('#' + $(this).data('target')).collapse('show')
      if $(this).data('test').indexOf('hide') == 0
        if $(this).val().toString() == $(this).data('test').replace('hide:','')
          if $('#' + $(this).data('target')).hasClass('in')
            $('#' + $(this).data('target')).collapse('hide')
        else
          $('#' + $(this).data('target')).collapse('show')
      if $(this).data('test').indexOf('show') == 0
        if $(this).val().toString() == $(this).data('test').replace('show:','')
          $('#' + $(this).data('target')).collapse('show')
        else
          if $('#' + $(this).data('target')).hasClass('in')
            $('#' + $(this).data('target')).collapse('hide')
      if $(this).data('test').indexOf('swap') == 0
        for val, target of $(this).data('target')
          if $('#' + target).hasClass('in')
            $('#' + target).collapse('hide')
        $('#' + $(this).data('target')[$(this).val().toString()]).collapse('show')

  $(document).on 'change', '.switch-on-change', ->
    for val, target of $(this).data('target')
      unless $('#' + target).hasClass('hidden')
        $('#' + target).addClass('hidden')
    $('#' + $(this).data('target')[$(this).val().toString()]).removeClass('hidden')

  hash = window.location.hash
  if $(hash).hasClass('collapse') && !$(hash).is(':visible')
    $(hash).collapse('show')

  update_dependent_options = (target, select) ->
    select.html select.data('options')[target.val()]
    select.val(select.data('orig-value')).trigger('change')
    if select.html().length > 0
      select.closest('.form-group').show()
    else
      select.closest('.form-group').hide()

  initialize_dependent_select = ->
    $('.dependent-select').each ->
      return if $(this).data('dependent-initialized')?
      select = $(this)
      target = if $(this).data('target-container')
        $(this).closest($(this).data('target-container')).find('.dependent-select-target')
      else
        $("##{$(this).data('target')}")
      unless select.data('orig-value')?
        select.data 'orig-value', $(this).val()
      update_dependent_options target, select
      target.on 'change', ->
        update_dependent_options target, select
      $(this).data 'dependent-initialized', true

  initialize_dependent_select()
  $('.dom_updatable').on 'dom_updated', initialize_dependent_select
  $(document).on 'show.bs.modal', '.modal', initialize_dependent_select
  $(document).on 'cocoon:after-insert', initialize_dependent_select
)
